export function authHeader() {

  return { 'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

}
